module.exports = __webpack_public_path__ + "img/7908096.jpg";